module.exports = __webpack_public_path__ + "img/up3.cda18ce6.png";